import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import MicrosoftExcelIcon from 'mdi-react/MicrosoftExcelIcon'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { DrillDownFilter } from '@/modules/admin/drilldown/DrillDownFilter'

import { exportDataToExcel } from '../helpers'

type DrillDownOptionsProps = {
  title: string
  data: Record<string, string | number>[]
  currencies: string[]
  hasSearch?: boolean
  columnFormats?: { [key: string]: string }
}

export const DrillDownOptions: FC<DrillDownOptionsProps> = ({
  data,
  title,
  currencies,
  hasSearch,
  columnFormats = {},
}) => {
  const translate = useTranslation()

  return (
    <div className="drill-down-options">
      <DrillDownFilter currencies={currencies} hasSearch={hasSearch} />
      <Button
        Icon={<MicrosoftExcelIcon />}
        disabled={data.length === 0}
        onClick={() =>
          exportDataToExcel(data, title, {
            translate,
            columnFormats,
          })
        }
      >
        <Translation id="export" />
      </Button>
    </div>
  )
}
